import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  id?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  tone = 'light',
  id
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={['max-w-2xl', align === 'center' ? 'mx-auto text-center' : ''].join(' ')} data-id="element-347" data-mp="3k0fabo8841ai">
      {eyebrow ? <p className={['mb-3 text-sm font-semibold', isDark ? 'text-gold' : 'text-gold-dark'].join(' ')} data-id="element-348" data-mp="gjzrfj67qmnd">
          {eyebrow}
        </p> : null}
      <h2 id={id} className={['font-display text-3xl leading-[1.15] sm:text-4xl', isDark ? 'text-white' : 'text-navy'].join(' ')} data-id="element-349" data-mp="6svcgjgjf1sj">
        {title}
      </h2>
      {description ? <p className={['mt-4 text-lg leading-relaxed', isDark ? 'text-navy-100' : 'text-ink/75'].join(' ')} data-id="element-350" data-mp="zb923vrpzhgj">
          {description}
        </p> : null}
    </div>;
}